// '온라인전용'
export const ONLINE_ONLY = '택배전용'

// '오늘배송전용'
export const QUICK_DELIVERY_ONLY = '오늘배송전용'
